export const GOOGLE_MAPS_API_KEY = "AIzaSyAIcEpl1QW7OFsEMWIOns_pPa_eyROqyZI"
export const GOOGLE_MAPS_MAP_ID = "ea7830d3f9301091"
